import React from "react";
import PropTypes from "prop-types";

function Image(props) {
  const {url, previewSrc, alt, handleClick} = props;
  return (
    <div className="picture">
      <a href="#" className="picture__img" onClick={handleClick(url)}>
        <img loading="lazy" src={previewSrc} alt={alt} />
      </a>
    </div>
  );
}

Image.propTypes = {
  url: PropTypes.string,
  previewSrc: PropTypes.string,
  alt: PropTypes.string,
  handleClick: PropTypes.func
};

export default Image;
